export default {
    pleaseChoose: "ကျေးဇူးပြု၍ ရွေးချယ်ပါ။"
}